import {isAdmin} from "../rolesSvc";
import {statusKeys as RS} from "../../helpers/projReportHelper";
import {status as PS} from "../../helpers/passport";


const rules = {
    Create: {
        isStatusOk:()=>true,
        isRoleOk:(userCtx) => isAdmin(userCtx),
    },
    AddDecision:{
        isStatusOk: (status) => [RS.onApproveExperts].includes(status),
        isRoleOk:(userCtx) => isAdmin(userCtx)
    },
    EditDecision:{
        isStatusOk: (status) => [RS.approved,RS.expertsApproved,RS.expertsDeclined].includes(status),
        isRoleOk:(userCtx) => isAdmin(userCtx)
    },
    See:{
        isStatusOk: (status) => ![RS.inProgress].includes(status),
        isRoleOk:(userCtx) => isAdmin(userCtx),
    },
    CloseProject:{
        isStatusOk:(status)=> [RS.expertsApproved,RS.approved,RS["-approved"]].includes(status),
        isRoleOk:(userCtx) => isAdmin(userCtx),
        extra:(status) => ![PS.closed,PS.onApproveExperts,PS.onApproveHeadSP,PS.onApproveCommittee,PS.onApprovePortf].includes(status)
    },
    EditCloseProject:{
        isStatusOk:(status)=> [RS.expertsApproved,RS.approved,RS["-approved"]].includes(status),
        isRoleOk:(userCtx) => isAdmin(userCtx),
        extra:(status) => [PS.closed].includes(status)
    }

}


export const getActionsModel = (userCtx,reportStatus,status) => Object.entries(rules).reduce((acc,[key,rule]) => ({
    ...acc,
    [key]: rule.isRoleOk(userCtx) && rule.isStatusOk(reportStatus) && (!rule?.extra || rule?.extra(status))
}),{})
